//import firebase from 'firebase/app';
import firebase from "firebase";
//import * as firebaseui from "firebaseui";
//import 'firebase/app';
//import * as firebaseui from "firebaseui";

import router from "./router/router";
import store from "./store/store";
import * as connect from './store/connect';
import { getFormattedDate, getCurrentDateISO8601, getCurrentDateISO8601Full } from './shared';

// TODO: Replace the following with your app's Firebase project configuration
// [.firebaserc]  "default": "architectassist-4a4d3"
// var firebaseConfig = {
// 	apiKey: "AIzaSyDbbzgCwOOlaV2x8U_nNl_qk4FA11vr2vY",
// 	authDomain: "architectassist-4a4d3.firebaseapp.com",
// 	databaseURL: "https://architectassist-4a4d3.firebaseio.com",
// 	projectId: "architectassist-4a4d3",
// 	storageBucket: "architectassist-4a4d3.appspot.com",
// 	messagingSenderId: "512603165708",
// 	appId: "1:512603165708:web:9b898a7bac725fd053ca29",
// 	measurementId: "G-4PC50NSWKD"
// };

// [.firebaserc]  "default": "loggable-co-uk"
var firebaseConfig = {
	apiKey: "AIzaSyAIwsgMzo0yKDGl1oF_2d3qYvQDOUw_pas",
	authDomain: "loggable-co-uk.firebaseapp.com",
	databaseURL: "https://loggable-co-uk.firebaseio.com",
	projectId: "loggable-co-uk",
	storageBucket: "loggable-co-uk.appspot.com",
	messagingSenderId: "497757341887",
	appId: "1:497757341887:web:4bdebbacea6e40ddc59e0a",
	measurementId: "G-00KP2KP6JY"
};

// Initialize Firebase
firebase.initializeApp(firebaseConfig);

// Initialize the FirebaseUI Widget using Firebase.
const auth = firebase.auth();
const ui = null;	//new firebaseui.auth.AuthUI(auth);		// firebaseui - BUT I don't want to use this anymore....
const db = firebase.firestore();

// function FromAlexVideoAsReference() {
// 	auth.createUserWithEmailAndPassword("email", "password").then(cred => { });
// 	auth.signInWithEmailAndPassword("email", "password").then(cred => { }).catch(error => alert(error.message));
// 	auth.onAuthStateChanged(user => { });
// 	auth.signOut();
// }

const registerWithEmailAndPassword = function (email, password, cbError) {
	auth.createUserWithEmailAndPassword(email, password)
		.catch(error => cbError(error.message));
};

const signinWithEmailAndPassword = function (email, password, cbError) {
	auth.signInWithEmailAndPassword(email, password)
		.catch(error => cbError(error.message));
};

const signinWithGoogle = function (cbError) {
	const provider = new firebase.auth.GoogleAuthProvider();		// we dont call the auth function here
	auth.signInWithPopup(provider)
		.catch(error => cbError(error.message));
};

const linkWithGoogle = function (cbError) {
	debugger;
	const onMobile = store.getters.onMobile;
	const provider = new firebase.auth.GoogleAuthProvider();		// we dont call the auth function here
	var authUser = store.getters.userAuth;
	if (authUser) {
		if (onMobile) {
			authUser.linkWithRedirect(provider)
				.then(/* ... */)
				.catch(error => cbError(error.message));
		}
		else {
			authUser.linkWithPopup(provider)
				.catch(error => cbError(error.message));
		}
	}
	else
		cbError("No valid user found to link Google with..");
};

const unlinkWithGoogle = function (cbError) {
	var authUser = store.getters.userAuth;
	authUser.unlink('google.com')
		.catch(error => cbError(error.message));
};

const signOut = function () {
	auth.signOut();
};

async function verifyAuthUserIsOKtoContinue(userAuth) {

	//debugger;

	try {
		let uid = userAuth.uid;

		let userInfo = await connect.getUserInfo(uid);

		if (userInfo == "error") {
			await store.dispatch("setUserInfo", null);
			return "error";
		}

		//debugger;

		// there is no known user - so this means user is registering (first time)
		if (!userInfo) {

			// so set up a few bits
			let date = new Date();
			var trialEnd = new Date(date.setMonth(date.getMonth() + 1));
			const obj = {
				uid,
				email: userAuth.email,
				emailVerified: userAuth.emailVerified,
				displayName: userAuth.displayName || 'no displayName',
				initialProvider: userAuth.providerId || 'no providerId',
				trialEnd: getCurrentDateISO8601(trialEnd),
				licensedUntil: "",
				lastLogin: "",
				accounting: "cash",
				dateFormat: "DD MMM YYYY",
				created: getCurrentDateISO8601Full(),
				statuses: ['Enquiry', 'Proposal', 'Closed', 'Current'],
				types: []
			};

			// write out some more userinfo properties
			let newUserInfo = await connect.createUserInfo(uid, obj);

			// now update 
			await store.dispatch("setUserInfo", newUserInfo);

		}
		else {
			// if there is a trialEnd date then check if we are within it
			if (userInfo.trialEnd) {
				let dateNow = getCurrentDateISO8601();
				if (dateNow > userInfo.trialEnd) {
					// trial has expired so auto logout the user for now
					//await store.dispatch("setLoginError", "your trial has ended");
					console.log("Your trial has expired");
					await auth.signOut();
					return;
				}
			}

			// hang on to the last logged in date
			await connect.updateUserInfo(uid, { lastLogin: getCurrentDateISO8601Full() });

			// now update 
			await store.dispatch("setUserInfo", userInfo);
		}
	}
	catch (error) {
		debugger;
		console.error("Error in verifyAuthUserIsOKtoContinue: " + error);
	}

}

auth.onAuthStateChanged(async userAuth => {

	console.log("auth.onAuthStateChanged - userAuth: " + userAuth);

	// if the userAuth is already the authorised user then return 
	if (store.getters.userAuth == userAuth) {
		console.log("***** onAuthStateChanged is the same - RETURNING");
		return;
	}

	let myPath = router.currentRoute.name;
	console.log("auth.onAuthStateChanged | router.currentRoute.name | -> " + myPath);

	//debugger;

	// if (myPath == "login") {
	// 	await store.dispatch("setUser", null);
	// 	return;
	// }


	// then do a proper dispatch
	console.log("auth.onAuthStateChanged - *** setUser: " + userAuth);
	await store.dispatch("setUser", userAuth);

	if (userAuth) {

		// do some checks against this uer
		let err = await verifyAuthUserIsOKtoContinue(userAuth);
		if (err) {
			debugger;
			await store.dispatch("setUser", null);
			return;
		}


		//console.log(data.user, data.credential.accessToken);
		console.log("***** ------>   onAuthStateChanged - OK - " + userAuth.uid);
		router.push({ name: 'projects' });
	} else {
		console.log("***** ------>   onAuthStateChanged - *** NO USER *** - rerouting to home");
		router.push({ name: 'home' });
	}
});

export { firebase, auth, ui, db, linkWithGoogle, unlinkWithGoogle, registerWithEmailAndPassword, signinWithEmailAndPassword, signinWithGoogle, signOut };